import {
    JagmCalculatedLocation,
    FixedDimension,
    JagmCalculatedSize,
    PercentDimension,
    JagmCalculatedMargin,
    JagmParentSettings,
    EJagmDockLayoutSector
} from "@incartdev/jagm-core";
import { JagmHtmlLabel, JagmHtmlLabelSettings } from "@incartdev/jagm-chart";
import GraphLibAdapter from "../../../../../graphics/graph-lib-adapter";

export class intervalSelectorGraphAdapter extends GraphLibAdapter {
    qrsMeasurer;
    tMeasurer;
    pMeasurer;
    label;

    cursorCallback;
    constructor(settings) {
        super(settings);

        this.cursorCallback = settings.cursorCallback;
    }

    setupCursors = async () => {
        this.findCursors();
        this.setupCursorsEventListeneres();
    };

    findCursors = () => {
        const charts = this.chartProvider.charts;
        let measurerContentGroup;

        for (const chart of charts) {
            measurerContentGroup = chart.findContentGroup("measurer");
            if (measurerContentGroup !== undefined) {
                break;
            }
        }

        this.pMeasurer = measurerContentGroup.findByName("P");
        this.qrsMeasurer = measurerContentGroup.findByName("QRS");
        this.tMeasurer = measurerContentGroup.findByName("T");
    };

    setupCursorsEventListeneres = () => {
        this.pMeasurer.addEventListener("PositionChanged", async target => {
            this.cursorCallback({
                P: Math.round(this.valueConverter.convertPixelsToPoints(target.position.x, this.fd)),
                PDur: Math.round(this.valueConverter.convertPixelsToPoints(target.position.width, this.fd))
            });
        });

        this.qrsMeasurer.addEventListener("PositionChanged", async target => {
            this.cursorCallback({
                Q: Math.round(this.valueConverter.convertPixelsToPoints(target.position.x, this.fd)),
                S: Math.round(this.valueConverter.convertPixelsToPoints(target.position.width, this.fd))
            });
        });

        this.tMeasurer.addEventListener("PositionChanged", async target => {
            this.cursorCallback({
                QTmax: Math.round(this.valueConverter.convertPixelsToPoints(target.position, this.fd))
            });
        });
    };

    setupLabel = async () => {
        const labelSector = this.chartProvider.charts[0].getCreatedSvgSectorPanel(EJagmDockLayoutSector.Central, 2, 0);
        this.createLabel(labelSector);
        this.label.init();
        this.label.typedSettings.html.ref.style.userSelect = "none";
    };

    createLabel = sector => {
        this.label = new JagmHtmlLabel(
            new JagmHtmlLabelSettings({
                location: new JagmCalculatedLocation({
                    x: new FixedDimension(10),
                    y: new FixedDimension(sector.typedSettings.sizeInPixels.height - 15)
                }),
                size: new JagmCalculatedSize({
                    width: new PercentDimension(0),
                    height: new PercentDimension(0)
                }),
                margin: new JagmCalculatedMargin({
                    right: new FixedDimension(0)
                }),
                parent: new JagmParentSettings({
                    ref: sector,
                    jagmHtml: sector
                }),
                html: {
                    parent: {
                        ref: sector.typedSettings.html.ref
                    }
                },
                fontSize: "12px",
                fontFamily: "Arial, sans-serif",
                title: "",
                color: [128, 128, 128, 255],
                isCentered: false
            })
        );
    };

    setLabelText = text => {
        this.label.setText(text);
    };

    moveCursors = async initialEcgComplexesPosition => {
        const { Q, S, P, PDur, QTmax } = initialEcgComplexesPosition;

        await this.tMeasurer.moveWithoutEvent(this.valueConverter.convertPointsToPixels(QTmax, this.fd));
        await this.qrsMeasurer.moveWithoutEvent({
            leftLinePosition: this.valueConverter.convertPointsToPixels(Q, this.fd),
            rightLinePosition: this.valueConverter.convertPointsToPixels(S, this.fd)
        });
        await this.pMeasurer.moveWithoutEvent({
            leftLinePosition: this.valueConverter.convertPointsToPixels(P, this.fd),
            rightLinePosition: this.valueConverter.convertPointsToPixels(P + PDur, this.fd)
        });
    };
}
